import React, { useEffect, useState } from "react";
import { Paper } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Add as AddIcon, NavigateNext as NavigateNextIcon, NavigateBefore as NavigateBeforeIcon, DeleteRounded as DeleteRoundedIcon, EditRounded as ModeEditOutlineRoundedIcon, AttachFileRounded as FileUploadRoundedIcon } from "@material-ui/icons";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { urlConfig } from "./config";
import Papa from "papaparse";

const MtnPlay = () => {
  const [newPopup, setNewPopup] = useState(false);
  const [data, setdata] = useState([]);
  const [vendorId, setVendorId] = useState(null);
  const [snackbar, setSnackbar] = useState(false);
  const [error, setError] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");
  const [filterJSON, setFilterJSON] = useState(null);
  const [jsonPopUp, setjsonPopUp] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const [actionData, setActionData] = useState(null);
  const [searchBy, setSearchBy] = useState("VendorID");
  const [disableNextButton, setDisableNextButton] = useState(false);
  const [userEmail, setUserEmail] = useState(false);
  const [editPopUp, setEditPopUp] = useState(false);
  const [operation, setOperation] = useState("");
  const [loading, setLoading] = useState(false);
  const [editData, setEditData] = useState({
    cid: null,
    vendorContentId: null,
    mtnJson: {
      age: null,
      url: "",
    },
  });

  const [file, setFile] = useState([]);

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  var urlFormat =
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;

  //-------------------Mounting----------------------------//

  useEffect(() => {
    Axios.get(
      `${urlConfig.cmsURL}/api/content/getPaginatedContent?page=${pageNo}`
    ).then((res) => {
      setdata(res.data);
    });
  }, [pageNo]);

  useEffect(() => {
    setUserEmail(sessionStorage.getItem("userEmail"));
  }, []);

  //-----------------------------API call----------------------------------------//

  const handleSubmit = () => {
    setOpenDialog(false);
    Axios.post(`${urlConfig.cmsURL}/api/content/getContentByCid`, {
      cid: actionData.cid,
      url: actionData.url,
      emailId: userEmail,
    })
      .then((res) => {
        setNewPopup(false);
        handleRefresh();
        setResponseMsg(res.data.Message);
        setSnackbar(true);
        setActionData(null);
      })
      .catch((err) => {
        setError(true);
        err.response.data.Message
          ? setResponseMsg(err.response.data.Message)
          : setResponseMsg("Facing issue, Contact CMS team");
        setSnackbar(true);
        // setNewPopup(false);
      });
  };

  const handlePushToDev = () => {
    setOpenDialog(false);
    setLoading(true);
    Axios.post(
      `${urlConfig.cmsURL}/api/push_to_dev?vendorContentId=${actionData}&emailId=${userEmail}`
    )
      .then((res) => {
        setResponseMsg(res.data.Message);
        setLoading(false);
        setSnackbar(true);
        handleRefresh();
        setActionData(null);
      })
      .catch((err) => {
        setError(true);
        setResponseMsg("Facing issue, Contact CMS team");
        setLoading(false);
        setSnackbar(true);
        setActionData(null);
      });
  };

  const handlePushToProd = () => {
    setOpenDialog(false);
    setLoading(true);
    Axios.post(
      `${urlConfig.cmsURL}/api/push_to_prod?vendorContentId=${actionData}&emailId=${userEmail}`
    )
      .then((res) => {
        setResponseMsg(res.data.Message);
        setLoading(false);
        setSnackbar(true);
        handleRefresh();
        setActionData(null);
      })
      .catch((err) => {
        setError(true);
        setResponseMsg("Facing issue, Contact CMS team");
        setLoading(false);
        setSnackbar(true);
        setActionData(null);
      });
  };

  const handleDelete = () => {
    setOpenDialog(false);
    Axios.delete(
      `${urlConfig.cmsURL}/api/content/deleteByVendorContentId?vendorContentId=${actionData}&emailId=${userEmail}`
    )
      .then((res) => {
        setResponseMsg(res.data.Message);
        setSnackbar(true);
        handleRefresh();
        setActionData(null);
      })
      .catch((err) => {
        setError(true);
        setResponseMsg("Facing issue.Contact CMS team");
        setSnackbar(true);
        setActionData(null);
      });
  };

  const handleSearchBy = (e) => {
    e.preventDefault();
    searchBy == "VendorID"
      ? Axios.get(
          `${urlConfig.cmsURL}/api/searchById?vendorContentId=${vendorId}&cid`
        )
          .then((res) => {
            setdata(res.data);
            setDisableNextButton(true);
          })
          .catch((err) => {
            setError(true);
            err.response.status === 404
              ? setResponseMsg("Invalid CID/VendorId")
              : setResponseMsg("Facing issue, Contact CMS team");
            setSnackbar(true);
          })
      : Axios.get(
          `${urlConfig.cmsURL}/api/searchById?vendorContentId&cid=${vendorId}`
        )
          .then((res) => {
            setdata(res.data);
            setDisableNextButton(true);
          })
          .catch((err) => {
            setError(true);
            err.response.status === 404
              ? setResponseMsg("Invalid CID/VendorId")
              : setResponseMsg("Facing issue, Contact CMS team");
            setSnackbar(true);
          });
  };

  const handleRefresh = () => {
    Axios.get(
      `${urlConfig.cmsURL}/api/content/getPaginatedContent?page=1`
    ).then((res) => {
      setdata(res.data);
      setDisableNextButton(false);
    });
  };

  const handleEditSubmit = (e) => {
    const updateUrl = editData.mtnJson.url;
    const UpdateVendorId = editData.vendorContentId;
    setOpenDialog(false);
    Axios.post(
      `${urlConfig.cmsURL}/api/updateUrl?vendorContentid=${UpdateVendorId}&url=${updateUrl}&emailId=${userEmail}`
    )
      .then((res) => {
        setEditPopUp(false);
        setResponseMsg(res.data.Message);
        setSnackbar(true);
        setActionData(null);
        handleRefresh();
      })
      .catch((err) => {
        setError(true);
        setResponseMsg("Facing issue in updating data");
        setSnackbar(true);
        setActionData(null);
      });
  };

  const handleUpload = () => {
    setLoading(true);
    const result = file.filter((e) => e.cid && e.url != "");
    Axios.post(
      `${urlConfig.cmsURL}/api/content/bulkUploadOfCidsAndUrl?emailId=${userEmail}`,
      result
    )

      .then((res) => {
        setFilterJSON(JSON.stringify(res.data, null, 2));
        setjsonPopUp(true);
        setLoading(false);
        document.getElementById("csv_input").value = "";
        setFile([]);
      })
      .catch((err) => {
        setError(true);
        setResponseMsg("Facing issue.Contact CMS team");
        setSnackbar(true);
      });
  };

  //-----------------------------------------------------------------------------//

  const handleConfirm = () => {
    if (operation === "pushToDev") {
      handlePushToDev();
    } else if (operation === "pushToProd") {
      handlePushToProd();
    } else if (operation === "delete") {
      handleDelete();
    } else if (operation === "edit") {
      handleEditSubmit();
    } else if (operation === "create") {
      handleSubmit();
    }

    //   handleDialogClose();
  };

  const handleJSON = (e) => {
    setFilterJSON(JSON.stringify(e.mtnJson, null, 2));
    setjsonPopUp(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar(false);
    setError(false);
    setResponseMsg("");
  };

  const handleDialogOpen = (operation, e) => {
    setOperation(operation);
    setActionData(e);
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setActionData(null);
  };

  const handleEdit = (e) => {
    setEditData(e);
    setEditPopUp(true);
  };

  const handleFileUploadChange = (e) => {
    Papa.parse(e.target.files[0], {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        if (results.data.length > 10) {
          setResponseMsg("Maximum 10 CID's only allowed");
          setError(true);
          setSnackbar(true);
        } else {
          setFile(results.data);
        }
      },
    });
  };

  return (
    <>
      <Paper sx={{ p: 3 }}>
        <Stack direction="row">
          <Stack direction="row" spacing={2}>
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Search by</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={searchBy}
                  label="Search by"
                  onChange={(e) => {
                    setSearchBy(e.target.value);
                  }}
                >
                  <MenuItem value="VendorID">VendorID</MenuItem>
                  <MenuItem value="CID">CID</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box component="form" onSubmit={handleSearchBy}>
              <TextField
                type="number"
                onChange={(e) => {
                  if (e.target.value > 0) {
                    setVendorId(e.target.value);
                  } else {
                    setResponseMsg("CID and vendorId should not be negative");
                    setError(true);
                    setSnackbar(true);
                  }
                }}
                required
              />
              <Button sx={{ m: 1 }} variant="contained" type="submit">
                Search
              </Button>
            </Box>
          </Stack>
          <Stack direction="row" spacing={2}>
            <Box sx={{ pt: 1 }}>
              <Button variant="contained" onClick={handleRefresh}>
                Refresh
              </Button>
              <Button
                variant="outlined"
                sx={{ ml: 2 }}
                onClick={() => {
                  setNewPopup(true);
                }}
              >
                NEW {<AddIcon />}
              </Button>
            </Box>
            <Box>
              <Button sx={{ m: 1 }}>
                <input
                  type="file"
                  id="csv_input"
                  accept=".csv"
                  onChange={handleFileUploadChange}
                />
              </Button>
              {file.length === 0 ? null : (
                <Button
                  variant="contained"
                  sx={{ ml: 1 }}
                  onClick={handleUpload}
                >
                  upload
                </Button>
              )}
            </Box>
          </Stack>
        </Stack>
        <Dialog open={newPopup} fullWidth>
          <Box
            component="form"
            onSubmit={(e) => {
              e.preventDefault();
              if (actionData.url.match(urlFormat)) {
                handleDialogOpen("create", actionData);
              } else {
                setError(true);
                setResponseMsg("Enter valid Url");
                setSnackbar(true);
              }
            }}
          >
            <DialogTitle>Create new content to MTN</DialogTitle>
            <Stack spacing={3}>
              <DialogContent>
                <Stack spacing={3}>
                  <TextField
                    label="CID"
                    variant="standard"
                    type="number"
                    onChange={(e) => {
                      if (e.target.value.length >= 5 && e.target.value > 0) {
                        setActionData({ ...actionData, cid: e.target.value });
                      } else {
                        setResponseMsg(
                          "CID must be minimum 5 digits and should not be negative"
                        );
                        setError(true);
                        setSnackbar(true);
                      }
                    }}
                    required
                  />
                  <TextField
                    label="URL"
                    variant="standard"
                    onChange={(e) => {
                      setActionData({ ...actionData, url: e.target.value });
                    }}
                    required
                  />
                </Stack>
              </DialogContent>
              <DialogActions>
                <Button variant="outlined" type="submit">
                  ADD
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    setActionData(null);
                    setNewPopup(false);
                  }}
                >
                  Cancel
                </Button>
              </DialogActions>
            </Stack>
          </Box>
        </Dialog>
        <Dialog open={jsonPopUp} fullWidth>
          <DialogContent>
            <pre>{filterJSON}</pre>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={(e) => {
                setjsonPopUp(false);
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={editPopUp} fullWidth>
          <Box
            component="form"
            onSubmit={(e) => {
              e.preventDefault();
              if (editData.mtnJson.url.match(urlFormat)) {
                handleDialogOpen("edit", null);
              } else {
                setError(true);
                setResponseMsg("Enter valid Url");
                setSnackbar(true);
              }
            }}
          >
            <DialogTitle>Edit</DialogTitle>
            <Stack spacing={3}>
              <DialogContent>
                <Stack spacing={3}>
                  <TextField
                    label="CID"
                    variant="standard"
                    type="number"
                    value={editData.cid}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  <TextField
                    label="VendorContent ID"
                    variant="standard"
                    value={editData.vendorContentId}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  <TextField
                    label="URL"
                    variant="standard"
                    value={editData.mtnJson.url}
                    required
                    onChange={(e)=>{
                      setEditData({
                        ...editData,
                        mtnJson: {
                          url: e.target.value,
                        },
                      });
                    }}
                  />
                </Stack>
              </DialogContent>
              <DialogActions>
                <Button variant="outlined" type="submit">
                  Submit
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    setEditPopUp(false);
                  }}
                >
                  Cancel
                </Button>
              </DialogActions>
            </Stack>
          </Box>
        </Dialog>
      </Paper>
      <Paper sx={{ mt: 3 }}>
        <TableContainer sx={{ maxHeight: 400 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell align="center">CID</TableCell>
                <TableCell align="center">VendorID</TableCell>
                <TableCell align="center">Push to Dev</TableCell>
                <TableCell align="center">Push to Prod</TableCell>
                <TableCell align="center">status</TableCell>
                <TableCell align="center">Created date</TableCell>
                <TableCell align="center">Push to Dev</TableCell>
                <TableCell align="center">Push to Prod</TableCell>
                <TableCell align="center">View JSON</TableCell>
                <TableCell align="center">Edit</TableCell>
                <TableCell align="center">Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">{row.cid}</TableCell>
                  <TableCell align="center">{row.vendorContentId}</TableCell>
                  <TableCell scope="row" align="center">
                    {row.pushToDev}
                  </TableCell>
                  <TableCell scope="row" align="center">
                    {row.pushToProd}
                  </TableCell>
                  <TableCell scope="row" align="center">
                    {row.status}
                  </TableCell>
                  <TableCell scope="row" align="center">
                    {row.createtime}
                  </TableCell>
                  <TableCell
                    scope="row"
                    align="center"
                    onClick={
                      row.pushToDev === 0
                        ? () => {
                            handleDialogOpen("pushToDev", row.vendorContentId);
                          }
                        : null
                    }
                  >
                    {
                      <Button disabled={row.pushToDev === 1 ? true : false}>
                        {<FileUploadRoundedIcon />}
                      </Button>
                    }
                  </TableCell>
                  <TableCell
                    scope="row"
                    align="center"
                    onClick={
                      row.pushToProd === 0
                        ? () => {
                            handleDialogOpen("pushToProd", row.vendorContentId);
                          }
                        : null
                    }
                  >
                    {
                      <Button disabled={row.pushToProd === 1 ? true : false}>
                        {<FileUploadRoundedIcon />}
                      </Button>
                    }
                  </TableCell>
                  <TableCell
                    scope="row"
                    align="center"
                    onClick={() => {
                      handleJSON(row);
                    }}
                  >
                    {<Button>JSON</Button>}
                  </TableCell>
                  <TableCell
                    scope="row"
                    align="center"
                    onClick={() => {
                      handleEdit(row);
                    }}
                  >
                    {<Button>{<ModeEditOutlineRoundedIcon />}</Button>}
                  </TableCell>
                  <TableCell
                    scope="row"
                    align="center"
                    onClick={() => {
                      handleDialogOpen("delete", row.vendorContentId);
                    }}
                  >
                    {<Button>{<DeleteRoundedIcon />}</Button>}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {!disableNextButton && (
        <Stack
          direction="row"
          spacing={3}
          justifyContent="center"
          sx={{ pt: 2, pb: 2 }}
        >
          <Button
            onClick={() => {
              setPageNo(pageNo - 1);
            }}
            disabled={pageNo == 1 ? true : false}
          >
            {<NavigateBeforeIcon />}Prev
          </Button>
          <Button
            onClick={() => {
              setPageNo(pageNo + 1);
            }}
            disabled={data.length !== 0 ? false : true}
          >
            Next{<NavigateNextIcon />}
          </Button>
        </Stack>
      )}
      <Snackbar
        open={snackbar}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={error ? "warning" : "success"}
          sx={{ width: "100%" }}
        >
          {responseMsg}
        </Alert>
      </Snackbar>

      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogContent>
          <h5> Are you sure you. Could we proceed it? </h5>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirm}>Yes</Button>

          {operation === "create" ? (
            <Button onClick={() => setOpenDialog(false)} variant="contained">
              No
            </Button>
          ) : (
            <Button onClick={handleDialogClose} variant="contained">
              No
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default MtnPlay;
